import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Subject }             from "rxjs";

@Injectable()
export class EcomanagerService {

  servicesAllowed: string[];

  private loadedSource = new Subject<Object>();
  loadedChange$ = this.loadedSource.asObservable();
  private loaded = false;

  constructor(private http: HttpClient) {
    this.servicesAllowed = ['ecompliance', 'cei', 'ecosensor', 'ecopricing'];
  }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  public getCredentials() {
    let url = 'api/v1/3pi';
    return this.http.get(url)
      .toPromise()
      .then((response: any) => this.persistCredentials(response) )
      .catch(error => this.errorHandler(error));
  }

  public getCredentialByServiceAndParam(service: string, param: string) : string {
    return localStorage.getItem(service + '_' + param);
  }

  public clearCredentials() {
    for (let service of this.servicesAllowed) {
      localStorage.removeItem(service + '_username');
      localStorage.removeItem(service + '_password');
    }
    this.loaded = false;
    this.loadedSource.next(false);
  }

  public isLoaded(){
    return this.loaded;
  }

  private persistCredentials(response) {
    if (response != null) {
      for (let item of response) {
        if (this.itemStructIsValid(item)) {
          let token = JSON.parse(item.token);
          localStorage.setItem(item.id.service + '_username', token['txtUsername']);
          localStorage.setItem(item.id.service + '_password', token['txtPassword']);
        }
      }
    }
    this.loaded = true;
    this.loadedSource.next(true);
  }

  private itemStructIsValid(item): boolean {
    if (item != null && item.token != null && item.id != null && item.id.service != null && this.servicesAllowed.indexOf(item.id.service) > -1)  {
      let token = JSON.parse(item.token);
      if (token['txtUsername'] != null && token['txtPassword'] != null) {
        return true;
      }
    }
    return false;
  }



}
